export const mockMessages = {
  header: 0,
  link: 1,
  video: 2,
  table: 3,
  options: 4,
  lorem: 7,
};

export const markdownTexts = [
  `# React Markdown h1 h2 h3
## Subtitle
### Additional info **especialistas**
`,
  `# React Markdown Link
## Subtitle
### Additional info **especialistas**
> This is a [link](https://github.com/remarkjs/react-markdown)
`,
  `# React Example Video
## Subtitle
### Additional info **especialistas**
> This is a ![video](https://www.youtube.com/watch?v=GBIIQ0kP15E)
`,
  `# React Markdown Table
- Some info
- Some info
## Subtitle
### Additional info **especialistas**
| Tables |  Are  |  Cool |
|----------|-------------|------|
| col 1 is |  left-aligned | $1600 |
| col 2 is |centered   |   $12 |
| col 3 is | right-aligned |$1 |
`,
  `# React Markdown Options
- Some text
- Some text 2
`,
  `# React Markdown Example
- Some text
- Some other text
## Subtitle
### Additional info **especialistas**
> This is a [link](https://github.com/remarkjs/react-markdown)
`,
  `# React Markdown Example
- Some Item
- Some other item
## Subtitle
### Additional info **especialistas**
> This is a [link](https://github.com/remarkjs/react-markdown)
`,
  `# Matris et sine supplex

Lorem markdownum plenaque raptu si radiare inque crescitque fata, sex mixta,
stillanti decipienda quae certa. Superest adcubuere de mihi sedit esse
Tirynthius sis ferebat cunas virginitate alios pro tela, hic iussa, **Iunosunt**.
Restabat *fuit coniunx*, torto Iunonem. Ea **Medusae portentificisquean**
longius vivere, nisi, hunc, humum luna undas tempore telo, monstris et,
excubias. Harenas maturus!

> Enim sub pactus, tuba quoque dederat moderatius illic. Poenas auctam, iubent
> sunt adlevet pede novitatis Minos dirimant ipso Oenidae furit iste meam
> vultuque sevocat arcem tuus, boves. Protinus trabibus, opesque arcus decebat
> iugera. Tuas curruque utere et succurrere parato si nisi temeraria,
> releguntque arbor ad. Fallere iussit tantum Arethusa; saliunt hic, et cardine
> parentis nec derectos!

Cum ventis tergum. Quaedam mihi remos pedes haud palmis **sine Lycei** inque
acies quibus est sumit captivo viribus. A stultos orbem caput mihi minimum rimis
squamea enim sine solutus violaeque gaudeat mihi.

- Orbe mota cum dixit neu feci
- Nec vocem relinquunt possum socio nominis parte
- Certe natus scite vota transit dexteriore

Ecce fecunda solidis; si quae ventis canori nitido cervice ne lux tantaeque
scelus. Bene ambagibus natam et iste putabat, et mitior nefandis membris. Terga
prospiciens et dumque morsusque [protectus temperat](#matris-et-sine-supplex),
quatiens est procul arboribus plagis precor ferrum blandaque?

Ferarum pars totum celeres paruerit et cultus ferre: ex erat! Soli barba,
tumulum cum retinet Chironis, quam illa *et graminis*. Tempora inobservata quae
hostem adhibere flamina, conbibit tamen *crudelia*, formae.

Radice nefas; nurus me oraque creatus *sic flumina* glacialis flectimur labique
inmemor; dextra. Inclinata Iovis, agant.
`,
  `# Dixit Proserpina viminaque litora Philomela tiaris arvum

## Vices virgineumque digiti facta

Lorem markdownum invitae ille veluti operis virgo suis sedes: verba enim. *Rudis semper terra*
locum clipeum, sanguineaque huius fruitur positae fecit de
gravisque plangi in pignora sedit invidiam.

Modo reducit pedum copia auxilium? Turba tergusque exterrita repono [infelix
valvis](#tam-caelo-superum) quam ramosam at videre debere annua clausas.
Patriaeque siccat; talis **ecce veniebat** veteris.

## Qua deorum ipse cremabo Telamon

Qui siccaeque aris baculo manus marito de noluit Thermodontiaco Iove cuspide
recentibus requievit dimotis Themis *ignotis stet*, tamen, ex. Quid ergo
pretiumque sors animavit fessa, et varias labore cum et Tmolus praebere finierat
tamen! De conorque adiecit vere quod: fugat leto Iunone dedisse exacta: laniger!
Audax inde movet exit cantus belli et servatoremque in nempe ora fauces vos
volucres secuti addit sistitur et verso. Dixit eo his inponis tamen ne mihi dat
sors lentae.

1. Inter in adducto crine
2. Inpulerat iamque qui corpora Aeolii
3. Te erat Indis ferro ante pedum mater

## Audentem liquido struxisse luce quae virgo inquit

Suco Mater hoc sequar. Recentia tum, a quam et more obstantis, fidere,
exstinctique macies dixi summa vesicam fuerunt non aspergine *lectum*. Cedit
regere.

## Tam caelo superum

Si corpore supple civit nemorale perlucidus saxo. Quas Acrisius tamen, virilem
Pico! Hausi animosa enim patria moderatius superbus.

1. Proelia sed gravis fero erat et posuerunt
2. Gradibus a dederat atricolor nova aspicite portus
3. Et percussaque Ammon germanam
`,
  `# Montibus caput dant fixit venerat o infelix

## Paulatim ad thyrso vocat contigit mansit momentaque

Lorem markdownum suppressa accipe, clausit tu nato sustinuit haec tum
iunctissima quam, dat habet dissipat tempora, nihil. Orbem profuga hyaenam
*Byblida Echionides* honorum Hyperione meruistis Iovis dum virtute avorum,
conplevit. Altera et lumina nuncupat collo iudicium, numquam fenestris mutasse
ducibusque roganti. Primus *per fera* eripiunt duasque? In miserque certa
regionibus purpureum **timido**; sine est semper, supplex ab atrorum mandata.

1. Aedes virgo
2. Mihi utque gaudere respicit
3. Lydas tolluntur sororum
4. Conataeque populusque visae

Quamvis infesto [in](#montibus-caput-dant-fixit-venerat-o-infelix) tamen
velleribus adest, maxima inclusas, ab [te opus
sagittas](#unda-corpore-tamen-ensem-calydon): et amantes tamen ait. Hortos
litora frigoris lacrimae haec rudi, suspiria noviens castrorum praefixo penderet
scopulis quoque terrigenasque. Vota tonitrumque illic,
[ira](#paulatim-ad-thyrso-vocat-contigit-mansit-momentaque) heros, at moveri
templo chaos inpediunt laude, incisa protinus. Adparet corpora fidem tolle **qui
pelagi**, spes in **latebras loca** vix valeant.
`,
];
